export { default } from './SocialMediaPosts';
